exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clipartItem{display:flex;margin:0 9px 13px 0;padding:5px;height:80px;border-radius:10px;background:#f9f9f9;box-shadow:0 3px 0 0 rgba(0,0,0,.14);padding:11px 5px 4px;min-height:50px;text-align:center;border:2px solid #f9f9f9;width:72px;float:left;flex:2;border:2px solid transparent;cursor:pointer;min-width:72px}.clipartItem div{position:relative;top:50%;left:50%;transform:translate(-50%,-50%);width:67px;height:67px;background-size:contain;background-repeat:no-repeat;background-position:50%}.clipartItem.active,.clipartItem:hover{border:2px solid #ea8d00;color:#ea8d00}.allCliparts ul{width:100%;height:90px;max-width:99999999999px;display:inline-block;float:left;display:flex}.allCliparts{width:100%;height:auto;float:left;overflow:auto;height:193px;overflow-y:hidden}.no-icon{line-height:60px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-985966e8","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Cliparts/Cliparts.vue
// module id = 112
// module chunks = 0